import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/serviceBookingsSagas";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";

export const CustomDateRanges = () => {
  const dispatch = useDispatch();

  const rangeOptions = useSelector((state) => state.serviceBookings.rangeOptions);
  const selectedRangeOption = useSelector((state) => state.serviceBookings.selectedRangeOption);

  return (
    <MultiSelectDropdown
      options={rangeOptions}
      selectedFilters={selectedRangeOption}
      includeFilter={false}
      onSelectChange={(data) => dispatch(actionCreators.updateCustomRange(data))}
    />
  );
};
